import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'

import tableIcons, { options } from 'components/universal/table_attributes'
import ViewIcon from "@material-ui/icons/Visibility";
import { getColors, getOrganisationId } from 'lib/utils/common_utils';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { useTheme, alpha, Table, Grid, Box } from '@material-ui/core';
import StatusButton from './StatusButton';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import ManageCoreDetails from 'views/Commercial/Parts/CoreExchange/SharedComponents/ManageCoreDetails';
import { FlyingSpannerServices } from 'lib/services/api/operaitons/WorkShop/FlyingSpanner/flyingspanner';




export default function CoreExchangeTable(props) {
    const { coreId,
        sales_order_core_id,
        repairFee,
        coreValues,
        setCoreData,
        setShippingFee,
        c_action,
        setLateFee,
        currentSelectedOrder,
        currency_id,
        permission } = props
    const theme = useTheme()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [action, setAction] = useState(null)
    const [totalCredit, setTotalCredit] = useState("0.00")
    const [currentSelection, setCurrentSelection] = useState(null)
    const [s_data, setSData] = useState([])
    const [defaultCurrency, setDefaultCurrency] = useState({})
    const tableOptions = {
        ...options,
        search: false,
        toolbar: false,
        paging: false,
        showFooter: true
    };

    const getCoreTableDetails = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            core_parent_id: coreId

        }
        setLoading(true)
        try {
            const response = await PartSalesServices.getSubCoreExchangeDetails(params)
            // setTotalCredit(+response?.total_credit > 0 ? +response?.total_credit.toFixed(2) : "0.00")

            if (response?.data.length > 0) {
                const value = response?.data.map((item) => {
                    if (item.id === sales_order_core_id && c_action === "edit") {
                        setShippingFee(item?.shipping)
                        setLateFee(item?.late_fee)
                        return {
                            ...item,
                            status: repairFee === "yes" ? "repair" : repairFee === "no" ? "rejected" : item.status,


                        }
                    }
                    else {
                        return item
                    }

                })

                setData(value)

            } else {
                setData(response?.data)

            }
            setCoreData(response?.data)
        }
        catch {

        }
        finally {
            setLoading(false)
        }


    }

    useEffect(() => {
        if (data.length > 0) {

            const total_value = data.reduce((acc, row) => {
                const value = parseFloat(row.credit ?? 0);
                return acc + (isNaN(value) ? 0 : value);
            }, 0);

            setTotalCredit(total_value > 0 ? total_value.toFixed(2) : "0.00")
        }
    }, [data])

    useEffect(() => {
        if (coreId) {
            getCoreTableDetails()
        }
    }, [coreId])

    useEffect(() => {
        if (coreValues || repairFee && c_action === "edit") {

            if (data.length > 0) {
                const value = data.map((item) => {
                    if (item.id === sales_order_core_id) {
                        let credit = 0
                        let total = (+item.shipping || 0) + (+coreValues?.lateFees || 0) + (+coreValues?.traceFees || 0) + (+coreValues?.repairFees || 0);
                        if (repairFee === "yes") {
                            credit = (+item?.core_value) - (+total)
                        } else {
                            credit = 0 - (+total)
                        }

                        return {
                            ...item,
                            status: repairFee === "yes" ? "repair" : repairFee === "no" ? "rejected" : item.status,
                            trace_fee: coreValues?.traceFees,
                            repair_fee: coreValues?.repairFees,
                            late_fee: coreValues?.lateFees,
                            credit: repairFee === "no" ? (+credit).toFixed(2) : repairFee === "yes" && +credit > 0 ? (+credit).toFixed(2) : 0
                        }
                    }
                    else {
                        return item
                    }

                })

                setData(value)
            }
        }

    }, [coreValues, repairFee])


    let currrencyDetails = {
        currency_name: currentSelectedOrder?.currency,
        sales_rate: currentSelectedOrder?.sales_rate,

        id: currency_id

    }
    let lateDetails = {

        late_fee_value: currentSelectedOrder?.late_fee_value


    }
    const handleClose = () => {
        setAction(null)
    }
    const getCurrency = () => {


        FlyingSpannerServices.fetchCurrency().then((res) => {
            if (res) {
                let value = res?.data.find((item) => item.default_status === true)
                setDefaultCurrency(value)
            }
        })
            .catch((err) => {
                //console.log({ err })
            });

    }
    useEffect(() => {
        if (action === "view") { getCurrency() }
    }, []);

    const commonProps = {
        handleClose: handleClose,
        action,
        disabled: false,
        defaultCurrency: defaultCurrency,
        currrencyDetails,
        quotationId: currentSelectedOrder?.sales_order_id,
        quotationDetails: lateDetails,
        ...currentSelection,
        tabName: "core_exchange",
        s_data: s_data,
        setSData: setSData,
        coreId,
        sales_order_id: currentSelectedOrder?.sales_order_id
    }



    const columns = [

        {
            title: "Status",
            field: "status",
            render: (rowData) =>


                <StatusButton status={rowData?.status} setAction={setAction} setCurrentSelection={setCurrentSelection} due_date={rowData?.date} rowDetails={rowData} type={c_action} getDetails={getCoreTableDetails} />



        },

        {
            title: "Type",
            field: "type",
            headerStyle: {

                textAlign: "left"
            },
            cellStyle: {

                textAlign: "left"
            }
        },
        {
            title: "Part #",
            field: "part",
            width: "12%",
            headerStyle: {
                width: "12%",
                textAlign: "left"
            },
            cellStyle: {
                width: "12%",
                textAlign: "left"
            },

        },
        {
            title: "Description",
            field: "description",
            width: "15%",
            headerStyle: {
                width: "15%",
                textAlign: "left"
            },
            cellStyle: {
                width: "15%",
                textAlign: "left"
            }

        },
        {
            title: "QTY",
            field: "qyt",
        },
        {
            title: "Core Value",
            field: "core_value",
        }, {
            title: "Shipping",
            field: "shipping",
        }, {
            title: "Late Fees",
            field: "late_fee",
        }, {
            title: "Trace Fees",
            field: "trace_fee",
        }, {
            title: "Repair Fees",
            field: "repair_fee",
        },

        {
            title: "Currency",
            field: "currency",
        },
        {
            title: "Credit *",
            field: "credit",
            render: (rowData) => <span style={{ color: +rowData?.credit <= 0 ? getColors("red") : getColors("green"), fontWeight: 600 }}>{rowData?.credit}</span>
        },



    ];





    return (
        <Box mt={"10px"} mb={"20px"}>

            <MaterialTable
                style={{ boxShadow: "0px 1px 3px #00000033", paddingBottom: "40px" }}
                icons={tableIcons}
                title={""}
                columns={columns}
                data={data || []}
                isLoading={loading}
                options={tableOptions}
                actions={c_action === "view" && [
                    {
                        icon: () => <ViewIcon fontSize="small" htmlColor={ICON_COLOUR} />,
                        tooltip: 'View',
                        onClick: (event, rowData) => {
                            setCurrentSelection(rowData);
                            setAction('view');
                        }
                    },

                ]}
            />

            <Grid container style={{
                position: "relative",
                marginTop: "-28px",
                paddingLeft: "23px",
                paddingRight: "12px",
                marginBottom: "30px"
            }} >
                <Grid item xs={7}>Total</Grid>
                <Grid item xs={3} style={{ textAlign: "right", fontSize: "12px", fontStyle: "italic" }}>Note - Total will return 0.00 if less than zero</Grid>
                <Grid item xs={2} style={{ textAlign: "right", fontWeight: 600 }}>{totalCredit}</Grid>


            </Grid>

            {action && action === "view" && <ManageCoreDetails handleClose={handleClose} currentSelection={commonProps} permission={props?.permission} />}




        </Box>
    )
}
